// @flow
import * as React from 'react';
import TimePicker from 'components/TimePicker';
import Field from './Field';

const TimePickerField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <TimePicker
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default TimePickerField;
